<template>
  <div style="display: inline-block;">
    <b-button
      variant="outline-dark"
      v-if="isStringData && url"
      :href="url"
      target="_blank"
    >
      <font-awesome-icon :icon="['fas', 'download']" /> Lebenslauf
    </b-button>

    <b-button
      variant="outline-dark"
      v-if="isObjectData && objectUrl"
      :href="objectUrl"
      :download="name"
      target="_blank"
    >
      <font-awesome-icon :icon="['fas', 'download']" /> Lebenslauf
    </b-button>
  </div>
</template>

<script>
import { storage } from "../plugins/firebase"
import { ref as storageRef, getBlob } from "firebase/storage"

export default {
  name: "ButtonBlob",
  props: {
    data: Object
  },
  data() {
    return {
      url: null,
      objectUrl: null,
      name: null
    };
  },
  computed: {
    isStringData() {
      return typeof this.data?.data === "string";
    },
    isObjectData() {
      return typeof this.data?.data === "object";
    }
  },
  methods: {
    async getImage() {
      const fileData = this.data?.data;
      if (this.isObjectData) {
        this.name = fileData.name;
        try {
          const blob = await getBlob(storageRef(storage, fileData.path));
          this.objectUrl = URL.createObjectURL(blob);
        } catch (e) {
          console.error("Download fehlgeschlagen:", e);
        }
      } else if (this.isStringData) {
        this.url = fileData;
      }
    }
  },
  mounted() {
    this.getImage();
  }
};
</script>
